import "./Contact.css";

const Contact = () => {
  return (
    <div className="container Contact">
      <div className="row ">
        <div className="col-md-12">
          <h1>Hurry up! Subscribe our newsletter and get 25% Off</h1>
          <h6>Limited time offer for this month. No credit card required.</h6>
        </div>
        <div className="col-md-8">
          <input type="text" placeholder="Email address" />
        </div>
        <div className="col-md-4">
          <button>Subscribe</button>
        </div>
      </div>
    </div>
  );
};

export default Contact;
